import Range from "./Range";
import DynamicText from "./DynamicText";
import MultiFunDynamicText from "./MultiFunDynamicText";
import DynamicLed from "./DynamicLed";
import SpCode from './SpCode';

export default (editor, opt = {}) => {
  Range(editor, opt);
  DynamicText(editor, opt);
  MultiFunDynamicText(editor, opt);
  DynamicLed(editor, opt);
  SpCode(editor, opt);
};
